import { useEffect } from 'react';
import { Box, LinearProgress } from '@mui/material';
import { usePlatformHandoff } from '../../services/platform-handoff';

/**
 * Leaves for the platform's app launcher, carrying the session across.
 *
 * A component rather than a `<Redirect>`, because the launcher is a different app on a
 * different origin — a router redirect can only move within this one.
 *
 * The session comes from the store, which is correct here: both atoms hydrate from
 * localStorage at module load, so a brand-new tab already has the token and the user
 * before this renders. (The login page cannot do that — see `goToPlatform`.)
 */
export const PlatformRedirect = () => {
  const goToPlatform = usePlatformHandoff();

  // In an effect, not during render: a full page navigation is a side effect, and React
  // may render this more than once before the browser leaves.
  useEffect(() => {
    goToPlatform();
    // Once. Re-running would restart a navigation that is already under way.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // The browser takes a moment to leave; show the same progress bar the router uses
  // while a chunk loads rather than flashing an empty page.
  return (
    <Box sx={{ width: '100%' }}>
      <LinearProgress />
    </Box>
  );
};

export default PlatformRedirect;
